
/* eslint-disable @typescript-eslint/camelcase */
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  PropType,
  ref
} from "vue";
import CountriesDropdown from "@/components/dropdown/VeeCountriesDropdown.vue";
import {
  CREATE_INLINE_VENUE_MODAL_ID,
  CREATE_VENUE_MODAL_VALIDATION_SCHEMA,
  VENUE_MODAL_EMITS
} from "@/components/venues/types";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Modal } from "bootstrap";
import { useStore } from "vuex";

export default defineComponent({
  name: "add-venue-inline-modal",
  components: { CountriesDropdown, Field, ErrorMessage, Form },
  emits: [VENUE_MODAL_EMITS.CREATED],
  props: {
    clientId: {
      type: [Number, null] as PropType<number | null>,
      default: () => null
    }
  },
  setup: function(props, { emit }) {
    const element = ref<HTMLElement | null>();
    const modal = ref<Modal | null>();
    const formKey = ref<number>(0);
    const client = ref<number | null>(null);
    const loading = ref<boolean>(false);
    const store = useStore();

    function setLoading(value: boolean): void {
      loading.value = value;
    }

    function bootstrapModal(): void {
      const el = document.getElementById(CREATE_INLINE_VENUE_MODAL_ID);
      if (el) {
        element.value = el;
        modal.value = new Modal(element.value);
      }
    }

    function handleOpenModal(): void {
      client.value = null;
      formKey.value++;
      nextTick(() => {
        modal.value.show();
        if (props.clientId) {
          client.value = props.clientId;
        }
      });
    }

    function toggleModal(toggle: boolean): void {
      if (modal.value) {
        if (toggle) {
          handleOpenModal();
        } else {
          modal.value.hide();
        }
      }
    }

    const modalId = computed<string>(
      (): string => CREATE_INLINE_VENUE_MODAL_ID
    );

    const validation = computed<object>(
      (): object => CREATE_VENUE_MODAL_VALIDATION_SCHEMA
    );

    function handleSubmit(data): void {
      const payload = {
        ...data,
        company_id: client.value ?? null
      };
      setLoading(true);
      store
        .dispatch("VenuesModule/createNew", payload)
        .then(({ data }) => {
          setLoading(false);
          emit(VENUE_MODAL_EMITS.CREATED, data);
          toggleModal(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }

    const companies = computed(() => {
      const data = computed(() => store.getters["ListsModule/companies"]);
      const array = [
        {
          value: null,
          label: "Own"
        }
      ];

      const client = data.value.find(i => i.value == props.clientId);
      if (client) {
        array.push({
          value: client.value,
          label: client.label
        });
      }
      return array;
    });

    onMounted((): void => {
      store.dispatch("ListsModule/fetchCompaniesAll");
      bootstrapModal();
    });

    return {
      handleSubmit,
      toggleModal,
      validation,
      companies,
      formKey,
      loading,
      modalId,
      client
    };
  }
});
